// extracted by mini-css-extract-plugin
export default {"image":"CY-z","loaded":"DY-z"};